import { render, staticRenderFns } from "./clubs.vue?vue&type=template&id=a52c10b4&scoped=true&"
import script from "./clubs.vue?vue&type=script&lang=js&"
export * from "./clubs.vue?vue&type=script&lang=js&"
import style0 from "./clubs.vue?vue&type=style&index=0&id=a52c10b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a52c10b4",
  null
  
)

export default component.exports